import {deleteRequest, get, post, put} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";


export const getUserInfoes = async (): Promise<DataResponse<any>> => {
    const url = `${endpoints.userInfo}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
  export const getUserPackage= async (): Promise<DataResponse<any>> => {
    const url = `${endpoints.getUserPackage}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
  export const getUserDopings = async (): Promise<DataResponse<any>> => {
    const url = `${endpoints.getUserDopings}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const getUserPermissions = async (): Promise<DataResponse<any>> => {
    const url = `${endpoints.getUserPermissions}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const updateUserPermissions = async (data:any): Promise<DataResponse<any>> => {
    const url = `${endpoints.updatePermissions}`;
    const config = headers.content_type.application_json;
    return put<DataResponse<any>>(url, data,config);
  };
  export const changePassword = async (data:any): Promise<DataResponse<any>> => {
    const url = `${endpoints.changePassword}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data,config);
  };
  export const deleteAccount= async (userId:string): Promise<DataResponse<any>> => {
    const url = `${endpoints.deleteAccount}/${userId}`;
    const config = headers.content_type.application_json;
    return deleteRequest<DataResponse<any>>(url, {},config);
  };

  export const uploadProfileImage = async (data:any): Promise<DataResponse<any>> => {
    const url = `${endpoints.uploadProfileImage}`;
    const config = headers.content_type.multipart_form_data;
    return post<DataResponse<any>>(url, data,config);
  };
  export const deleteProfileImage= async (userId:string): Promise<DataResponse<any>> => {
    const url = `${endpoints.deleteProfileImage}/${userId}`;
    const config = headers.content_type.application_json;
    return deleteRequest<DataResponse<any>>(url, {},config);
  };

  export const updateProfileInfoes = async (data:any): Promise<DataResponse<any>> => {
    const url = `${endpoints.updateProfileInfoes}`;
    const config = headers.content_type.application_json;
    return put<DataResponse<any>>(url, data,config);
  };

  export const updatePhoneAfterVerify = async (data:any): Promise<DataResponse<any>> => {
    const url = `${endpoints.updateUserPhoneNumber}`;
    const config = headers.content_type.application_json;
    return put<DataResponse<any>>(url, data,config);
  };